import api from '.././api'
import router from "../router";
import {vuexTimeData} from "../util/vuexData";

export default {
  name: 'QqTransition',
  data() {
    return {
      timer: null  // 定时器名称
    }
  },
  mounted() {
    this.timer = setInterval(this.qqLogin, 1); // 定时器
  },

  methods: {
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    getQuery(name) {
      let after = window.location.hash.split("?")[1];
      if (after) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = after.match(reg);
        if (r != null) {
          return decodeURIComponent(r[2]);
        } else {
          return null;
        }
      }
    },

    /**
     * 给VUEX赋值
     */
    vuexToValue(result) {
      let userInfo = {}
      let localStorage = window.localStorage;
      if (localStorage) {
        if (result.userToken === "" || result.userToken == null || result.userToken == undefined) {
          userInfo.userToken = localStorage.getItem('thesis-userToken');
        } else {
          localStorage.setItem('thesis-userToken', result.userToken);
        }
      }
      userInfo.userToken = result.userToken
      userInfo.userId = result.id
      userInfo.userName = result.userName
      userInfo.userTypeEnum = result.userTypeEnum
      userInfo.certificateStatus = result.certificateStatus
      userInfo.userPhone = result.userPhone
      userInfo.type = 1
      router.app.$options.store.state.user = userInfo;
      return userInfo
    },

    // QQ第三方登录
    qqLogin() {
      var that = this; // 先将vue这个对象保存在_self对象中
      let vue = this
      let qqState = this.getQuery('state')
      qqState = qqState.substring(0, qqState.indexOf('#'))
      // 清除定时器
      clearInterval(that.timer);
      that.timer = null;
      //检查是否登录
      if (QC.Login.check()) {
        //该处的openId，accessToken就是后台需要的参数了，后台可以通过这些参数获取临时登录凭证，然后就是自己的逻辑了
        QC.Login.getMe(function (openId, accessToken) {
          if (openId != undefined) {
            // 传参给后台进行登录验证
            //console.log("qqstate"+qqState)
            // console.log("accessToken"+accessToken)
            api.login.logincallbackOfQQ(accessToken, qqState).then(function (response) {
              /*that.loading = false;
              that.$router.push({path: '/'})*/
              if (response.data.code === "0") {
                let url = window.location.href;
                if (url.indexOf("?") != -1) {
                  url = url.replace(/(\?|#)[^'"]*/, '');
                  window.history.pushState({}, 0, url);
                }
                let result1 = response.data.result
                let userInfo = vue.vuexToValue(result1)
                if (typeof (result1.state) === 'undefined') {
                  api.login.getGameInfo().then(function (response) {
                    if (response == null) {
                      return null
                    }
                    if (response.data.code === "0") {
                      let result = response.data.result
                      vuexTimeData(result)
                    }
                  })
                } else {//当前qq暂未绑定本平台账号,请先绑定
                  //router.push({path: '/binding', query: {state: qqState, type: 'qq'}})
                  that.$busEvent.$emit('onBindingQQ',qqState,'qq')
                }
                router.push({path: '/'})
              }
            }).catch(error => {
              router.push({path: '/'})
            })
          }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/QqTransition.js